<template>
  <div class="file__container" @click="$emit('itemClick')">
    <v-icon color="success">mdi-attachment</v-icon>
    <div class="text-left flex-grow-1">
      <p class="file__name">{{ file.name }}</p>
      <p class="file__size" v-if="file.size">{{ file.size | fileSize }}</p>
    </div>
    <RemoveIconButton v-if="!isReadonly" @click.stop="$emit('remove')"></RemoveIconButton>
  </div>
</template>

<script>
import RemoveIconButton from '@/component/Button/remove-icon-button';

export default {
  name: 'FileStatus',
  components: {
    RemoveIconButton,
  },
  props: {
    file: {
      required: true,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/core/style/variables'  as *;

.file {
  &__container {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px;
    gap: 8px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
  }

  &__name {
    font: 400 15px/18px $base-font;
    color: $text-color--primary;
    margin-bottom: 0;
  }

  &__size {
    font: 400 13px/15px $base-font;
    color: $text-color--secondary;
    margin-bottom: 0;
  }
}
</style>
